import React from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

import SlidingSwitch from "../../../../components/SlidingSwitch/index";
import AdminOnly from "../../../../components/AdminOnly";

const ActiveServices = ({ list, selected, handleChange, handleUpdate }) => {
  const {
    control,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  return (
    <div className="grid">
      <div className="col-12">
        <p className="general-info">Active Services.</p>
        <p className="general-info-para">
          Select all contracted services for this partner.
        </p>
      </div>
      {list?.map((x) => {
        const label = x?.name?.toLowerCase()?.includes("payroll")
          ? "Local Team Payslip link"
          : "EoR external link";
        const tooltipvalue = x?.name?.toLowerCase()?.includes("payroll")
          ? "This unique link grants Local Teams access to this entity's Payslip account."
          : "This unique link grants Local Teams access to this entity’s EoR external tool account";
        return (
          <div
            className="col-6 lg:col-6 md:col-12 sm:col-12 xs:col-12"
            key={x.id}
          >
            <Card
              className="p-card p-component"
              style={{
                border: "1px solid #ddd",
                boxShadow: "none",
                padding: 15,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <div className="flex justify-content-between align-items-center mb-2">
                <div
                  className="service__icon__container"
                  style={{
                    backgroundColor: x?.secondary_color,
                  }}
                  dangerouslySetInnerHTML={{ __html: x.icon }}
                />
                <SlidingSwitch
                  checked={selected.some((service) => service.id === x.id)}
                  onChange={() => handleChange(x.id)}
                />
              </div>
              <h3 className="m-0">
                <b>{x.name}</b>
              </h3>
              <p className="mt-2">{x.description}</p>

              {selected.some((service) => service.id === x.id) && (
                <AdminOnly>
                  <label className="contact-label mt-2 pb-2">
                    {label}{" "}
                    <span
                      id={`payslip-info-${x.id}`}
                      className="pi pi-info-circle"
                    ></span>
                    <Tooltip
                      target={`#payslip-info-${x.id}`}
                      content={tooltipvalue}
                      position="bottom"
                      className="custom-tooltip tooltip-custom-format"
                    />
                  </label>

                  <Controller
                    name={`lsp_pay_url_${x.id}`}
                    control={control}
                    rules={{
                      // required: "Payslip URL is required.",
                      pattern: {
                        value:
                          /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(\/\S*)?$/,
                        message: "Please enter a valid URL.",
                      },
                    }}
                    render={({ field }) => (
                      <div className="mt-2">
                        <InputText
                          {...field}
                          value={
                            selected.find((service) => service.id === x.id)
                              ?.lsp_pay_url || ""
                          }
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            handleUpdate(e, x.id);
                          }}
                          type="text"
                          placeholder={`Enter ${label}`}
                          data-testid={`lsp_pay_url_${x.id}`}
                          className={`mt-2 input-field appearance-none outline-none w-full ${
                            errors[`lsp_pay_url_${x.id}`] ? "p-invalid" : ""
                          }`}
                        />
                        {errors[`lsp_pay_url_${x.id}`] && (
                          <small className="p-error">
                            {errors[`lsp_pay_url_${x.id}`]?.message}
                          </small>
                        )}
                      </div>
                    )}
                  />
                </AdminOnly>
              )}
            </Card>
          </div>
        );
      })}
    </div>
  );
};

ActiveServices.propTypes = {
  list: PropTypes.array,
  selected: PropTypes.array,
  handleUpdate: PropTypes.func,
  handleChange: PropTypes.func,
};

export default ActiveServices;
